const authRoutesUrls = {
  signIn: `/sign-in`,
  signUp: `/sign-up`,
};

export default authRoutesUrls;
